import React, { useState, useEffect } from "react";
import { func, string } from "prop-types";
import { connect } from "react-redux";
import { parseUrl } from "query-string";
import get from "lodash/get";

import { resetPassword } from "../../helper/api";
import { setUserLoggedIn, setLoading } from "../../helper/actions";

import TextField from "../../atoms/textfield";
import Button from "../../atoms/button";
import ErrorView from "../../molecules/error-view";

import "./reset-password.m.css";

const ResetPasswordView = ({ currentPath, setUserLoggedIn, navigateToPage, setLoading }) => {
  const [user, setUser] = useState({
    password: "",
    repeatPassword: ""
  });
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null); // Store the token which is received in the query params

  useEffect(() => {
    // To be called only once during the first load
    const params = parseUrl(currentPath);

    if (params) {
      // Validate the opt and member id
      const queryToken = get(params, ["query", "token"], "");

      if (queryToken) {
        // Set the state if both exists
        setToken(queryToken);
      } else {
        setError("Invalid Request !! Please try again");
      }
    } else {
      setError("Invalid Request !! Please try again");
    }
  }, []);

  const setData = e => {
    const userObj = { ...user };
    const fieldName = e.target.name;
    userObj[fieldName] = e.target.value;

    // If error has been set then remove it
    if (e.target.value && userObj[`${fieldName}Error`]) {
      userObj[`${fieldName}Error`] = "";
    }

    // If error is set remove it since data is changed
    if (error) {
      setError(null);
    }

    setUser(userObj);
  };

  const onSubmitClick = event => {
    event.preventDefault();

    if (validate()) {
      // true -> field errors, false - no fields errors
      return;
    }

    // If error is set remove before making api call
    if (error) {
      setError(null);
    }

    setLoading(true);

    resetPassword(token, user.password, user.repeatPassword)
      .then(response => {
        setUserLoggedIn(true, response.member);
        navigateToPage("/publications");
      }) // On success
      .catch(() => setError("Invalid Request !! Please try to do a forgot password again."))
      .finally(() => setLoading(false));
  };

  const validate = () => {
    const updatedUser = { ...user };
    let flag = false;

    if (!updatedUser.password) {
      updatedUser.passwordError = "Password field cannot be left blank !!";
      flag = true;
    } else {
      updatedUser.passwordError = "";
    }

    if (!updatedUser.repeatPassword) {
      updatedUser.repeatPasswordError = "Password field cannot be left blank !!";
      flag = true;
    } else {
      updatedUser.repeatPasswordError = "";
    }

    if (updatedUser.password && updatedUser.repeatPassword) {
      // If password's exists then check if both are same
      if (updatedUser.password !== updatedUser.repeatPassword) {
        setError("Password and Repeat Password do not match");
        flag = true;
      }
    }

    // If flag is true, there are field error's
    if (flag) {
      setUser(updatedUser); // update state with field errors
    }

    return flag;
  };

  const closeErrorClick = () => {
    if (token) {
      setError(null);
    }
  };

  const mainView = (
    <React.Fragment>
      <TextField
        value={user.password}
        error={user.passwordError}
        placeholder="password"
        label="Enter your new password"
        type="password"
        name="password"
        onChange={setData}
      />
      <TextField
        value={user.repeatPassword}
        error={user.repeatPasswordError}
        placeholder="repeat password"
        label="Enter your new password again"
        type="password"
        name="repeatPassword"
        onChange={setData}
      />
      <div styleName="actions-wrapper">
        <Button content="VERIFY" type="submit" />
      </div>
    </React.Fragment>
  );

  return (
    <div>
      <div styleName="top-content">
        <span styleName="label">RESET PASSWORD</span>
      </div>
      <div styleName="bottom-content">
        <form onSubmit={onSubmitClick}>
          <div styleName="wrapper">
            <ErrorView error={error} closeClick={closeErrorClick} />
            {token ? mainView : null}
          </div>
        </form>
      </div>
    </div>
  );
};

ResetPasswordView.propTypes = {
  currentPath: string,
  setUserLoggedIn: func,
  navigateToPage: func,
  setLoading: func
};

const mapDispatchToProps = dispatch => ({
  setUserLoggedIn: (isUserLoggedIn, user) => dispatch(setUserLoggedIn(isUserLoggedIn, user)),
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

const ResetPasswordPage = connect(
  null,
  mapDispatchToProps
)(ResetPasswordView);

export { ResetPasswordPage };
